const colors = {
  primary: "#9e9e9e",
  secondary: "#9c27b0",
  tertiary: "#000000",
};

export default colors;
